import Vue from 'vue'
import VueRouter from 'vue-router'
// import scrollBehavior from './scroll-behavior'
import PagesMenu from '@/pages/menu/menu'

const PagesHome = () => import('@/pages/home/home')
const PagesAboutUs = () => import('@/pages/about-us/about-us')
// const PagesMenu = () => import('@/pages/menu/menu')
const PagesPress = () => import('@/pages/press/press')
const PagesGallery = () => import('@/pages/gallery/gallery')
const PagesCareers = () => import('@/pages/careers/careers')
const PagesLocations = () => import('@/pages/locations/locations')
const Contact = () => import('@/pages/contact-us/contact-us')
const PageNotFound = () => import('@/pages/404/404')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/menu-1.jpg',
      component: PagesHome
    },
    {
      path: '/about-us',
      name: 'About',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/gallery-18.jpg',
      component: PagesAboutUs
    },
    {
      path: '/menu',
      name: 'Menu',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/menu-2.jpg',
      component: PagesMenu
    },
    {
      path: '/locations',
      name: 'Locations',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/menu-4.jpg',
      component: PagesLocations
    },
    {
      path: '/careers',
      name: 'Careers',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/menu-5.jpg',
      component: PagesCareers
    },
    {
      path: '/gallery',
      name: 'Gallery',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/menu-gallery-bg.jpg',
      component: PagesGallery
    },
    {
      path: '/press',
      name: 'Press',
      navigation: true,
      bg: 'https://d1ppz47dg1ugzu.cloudfront.net/menu/menu-6.jpg',
      component: PagesPress
    },
    {
      path: '/contact-us',
      name: 'Contact Us',
      navigation: false,
      component: Contact
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js